import {FC, ReactElement} from "react";
import {FormControl, FormControlLabel, FormGroup, FormLabel, Radio} from "@mui/material";
import {Field, FieldProps, FieldRenderProps} from "react-final-form";

interface RadioFieldProps extends FieldRenderProps<boolean> {
  disabled?: boolean;
  label: ReactElement;
  radioValue: string;
}

/**
 * Represents a radio field component.
 */
const RadioField: FC<RadioFieldProps> = ({input, radioValue, disabled, ...custom}) => (
  <FormControl>
    <FormControlLabel
      control={
        <Radio
          checked={input.checked} onChange={input.onChange}
          color={"primary"} value={radioValue}
          disabled={disabled}
        />
      }
      {...custom}
    />
  </FormControl>
);

interface RadioGroupFieldProps {
  column?: boolean;
  disabled?: boolean;
  label: ReactElement;
  labels: ReactElement[];
  name: string;
  required?: boolean;
  validate?: FieldProps["validate"];
}

/**
 * Represents a radio group field that allows the selection of one option from a set of options.
 */
const RadioGroupField: FC<RadioGroupFieldProps> = ({name, label, labels, required, column, disabled}) => (
  <FormControl
    required={required} disabled={disabled}
    component={"fieldset"}
    variant="filled" fullWidth
  >
    <FormLabel component={"legend"}>{label}</FormLabel>
    <FormGroup row={!column}>
      {
        labels.map((label,index) => (
          <Field
            name={name} key={`radio_${index}`}
            value={`${index}`} radioValue={`${index}`}
            component={RadioField} type={"radio"}
            label={label}
            disabled={disabled}
          />
        ))
      }
    </FormGroup>
  </FormControl>
);

export {
  RadioField, RadioGroupField
};
